import moment from 'moment';

export default class OrganizationDateTimeFormat
{
  static formatTokenTypes = {
    MOMENTJS: 0
  };

  static formatTokenTypeValues = Object.values(OrganizationDateTimeFormat.formatTokenTypes);

  static defaultFormatToken = 'DD MMMM YYYY';

  static defaultUtcOffset = 0;

  static defaultFormatTokenType = OrganizationDateTimeFormat.formatTokenTypes.MOMENTJS;

  constructor(...args)
  {
    const options = args.length === 2 ? args[1] : args[0] || {};
    const { formatTokenType, formatToken, utcOffset } = options;

    this.formatTokenType = OrganizationDateTimeFormat.formatTokenTypeValues.includes(formatTokenType)
      ? formatTokenType
      : OrganizationDateTimeFormat.defaultFormatTokenType;
    this.formatToken = typeof formatToken === 'string' ? formatToken : OrganizationDateTimeFormat.defaultFormatToken;
    this.utcOffset = typeof utcOffset === 'number' ? utcOffset : OrganizationDateTimeFormat.defaultUtcOffset;
  }

  format(date)
  {
    switch (this.formatTokenType)
    {
      case OrganizationDateTimeFormat.formatTokenTypes.MOMENTJS:
        return this.formatDateWithMomentJs(date);

      default:
        return this.formatDateWithMomentJs(date);
    }
  }

  formatDateWithMomentJs(date)
  {
    return moment(date)
      .utcOffset(this.utcOffset)
      .format(this.formatToken);
  }
}
